howspace.search = (() => {
    'use strict';

    const searchInput = document.querySelector('#workspace-search');
    const clearSearchBtn = searchInput ? searchInput.nextElementSibling : null;
    const searchResults = document.querySelector('#search-results');

    const retryTimeLimit = 30000;

    let lastQuery = '';
    let queryStartTime = null;
    let timer;

    real.dom.$body.on('click', '.search-btn', (e) => {
        const search = $('#search');
        howspace.components.dropdown.close(e.target.closest('.dropdown'));
        if (search.hasClass('expanded')) {
            howspace.workspace.sidebar.close();
        } else {
            howspace.workspace.sidebar.open(search);
        }
    });

    return {
        init: () => {
            if (!searchInput) {
                return;
            }

            if (!searchResults) {
                return;
            }

            howspace.search.initPagination();

            real.onTierReady(real.TIER_2, () => {
                searchInput.addEventListener(howspace.components.searchInput.SEARCH, () => {
                    queryStartTime = null;
                    howspace.search.prepare(searchInput.value);
                    howspace.search.fetch(searchInput.value);
                });
            });

            clearSearchBtn.addEventListener('click', () => {
                lastQuery = '';
                searchInput.value = '';
                searchInput.focus();
                searchResults.classList.remove('howspace-loader', 'medium');
                searchResults.innerHTML = '';
            });
        },

        shouldFetch(query) {

            // If the search input is empty, clear the search results div and don't fetch
            if (searchInput.value.length < 1) {
                clearSearchBtn.dispatchEvent(new Event('click'));
                return false;
            }

            // If we are spinning, we should always fetch
            if (searchResults.classList.contains('howspace-loader')) {
                return true;
            }

            // If the query hasn't changed, no need to fetch
            return query.trim() !== lastQuery;
        },

        prepare: (query) => {
            if (!howspace.search.shouldFetch(query)) {
                return;
            }

            howspace.search.spin();
        },

        spin: () => {
            searchResults.innerHTML = '';
            searchResults.classList.add('howspace-loader', 'medium');
        },

        fetch: (query, page = 1) => {

            if (!howspace.search.shouldFetch(query)) {
                return;
            }

            lastQuery = query;

            real.ajax.html(real.baseUri + '/search/results', {
                data: {
                    'q': query,
                    'page': page
                },
                type: 'GET',
                success: function (response) {

                    if (searchInput.value.length > 0) {
                        searchResults.innerHTML = response;
                    }

                    howspace.search.initPagination();

                    searchResults.classList.remove('howspace-loader', 'medium');

                    const rejected = searchResults.querySelector('.search-rejected')
                    if (rejected) {
                        if (queryStartTime === null) {
                            queryStartTime = Date.now();
                        }
                        const delay = rejected.dataset.retryDelay || 1000;
                        howspace.search.spin();
                        searchResults.innerHTML = response;
                        clearTimeout(timer);
                        timer = setTimeout(() => {
                            let remainingTime = retryTimeLimit - (Date.now() - queryStartTime);
                            if (remainingTime < 0) {
                                searchResults.classList.remove('howspace-loader', 'medium');
                                searchResults.innerHTML = '';
                                return;
                            }
                            howspace.search.fetch(searchInput.value);
                        }, delay);
                    }
                }
            });
        },

        initPagination: () => {
            // Find the pagination links under searchResults
            const paginationLinks = searchResults.querySelectorAll('.search-pagination a');

            // Add click event to each pagination link
            paginationLinks.forEach((link) => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();

                    const page = link.dataset.searchpage;
                    const query = link.dataset.searchquery;

                    lastQuery = '';
                    howspace.search.prepare(query);
                    howspace.search.fetch(query, page);
                });
            });
        }
    }

})();

howspace.search.init();
